var pi = Math.PI,
    halfPi = pi / 2;
export function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}
export function sinOut(t) {
  return Math.sin(t * halfPi);
}
export function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-ease@1.0.6@d3-ease/src/sin.js
// module id = 203
// module chunks = 0 1 2